import createTaxonomyMap from '../utils/createTaxonomyMap'

export default function storeProductCatalogTaxonomies(queryResults, store) {
  return store.dispatch('productCatalog/storeTaxonomies', createTaxonomyMap(queryResults))
}
